<div class="widget-container flex-box">
  @if (uploadedFile) {
    <div class="file-zone px-6 flex flex-row justify-between relative w-full">
      <div class="flex flex-col">
        <div class="flex gap-4 items-start">
          <img src="../../../../assets/icons/file.svg" width="28" height="28" alt="file icon" />
          <div class="text-base text-dark-grey">
            <p>{{uploadedFile.name}}</p>
            @if (uploadedFileSize) {
              <p>{{uploadedFileSize}}</p>
            }
          </div>
        </div>
        @if (progressVisible) {
          <div class="w-full mt-2">
            <div class="w-full bg-neutral-200 rounded-full h-1.5">
              <div class="bg-primary-600 h-1.5 rounded-full transition-all"
              [style.width.%]="progressValue"></div>
            </div>
          </div>
        }
      </div>
      <a (click)="removeFile($event)" class="cursor-pointer">
        <img src="../../../../assets/icons/trash.svg"
          width="20"
          height="20"
          alt="trash icon" />
      </a>
    </div>
  } @else {
    <div #dropZoneExternal
      id="dropzone-external"
      class="flex-box cursor-pointer"
      (click)="onDropZoneClick()"
      (dragover)="onDragOver($event)"
      (dragenter)="onDragEnter($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      [ngClass]="{
        'dropzone-active': isDropZoneActive,
        'dropzone-success': dropZoneValidationState === 'success',
        'dropzone-error': dropZoneValidationState === 'error'
      }">
      <div id="upload-trigger" class="flex flex-col items-center justify-center gap-4">
        <img src="../../../../assets/icons/upload-cloud.svg"
          width="68px"
          height="68px"
          alt="import cloud icon" />
        <div class="text-center text-dark-grey text-base font-normal flex flex-col items-center justify-center gap-1 px-4">
          <div class="flex gap-1">
            <label class="cursor-pointer text-orange-500 underline">
              Click to Upload
            </label>
            <p>or drag and drop</p>
          </div>
          <p class="max-w-[500px]">
            You may attach maximum file size of {{convertFileSize(maxFileSize)}}. File extension: {{allowedFileExtensions.join(', ')}}
          </p>
        </div>
      </div>
    </div>
    <input #fileInput
      id="native-file-input"
      type="file"
      class="hidden"
      [accept]="allowedFileExtensions.join(',')"
      (change)="onFileSelected($event)" />
  }

</div>